// src/components/RoleDialog.js
import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Grid, FormGroup, FormControlLabel, Checkbox, Typography, Divider } from '@mui/material';

const allPermissions = [
  { id: 'full_access', label: 'Toàn quyền truy cập (Bỏ qua tất cả các quyền khác)' },
  { id: 'viewDashboard', label: 'Xem Dashboard' },
  { id: 'viewImports', label: 'Xem Hàng Nhập' },
  { id: 'createImports', label: 'Tạo phiếu Nhập' },
  { id: 'editImports', label: 'Sửa phiếu Nhập (chưa duyệt)' },
  { id: 'deleteImports', label: 'Xóa phiếu Nhập (chưa duyệt)' },
  { id: 'approveImports', label: 'Duyệt phiếu Nhập' },
  { id: 'viewExports', label: 'Xem Hàng Xuất' },
  { id: 'createExports', label: 'Tạo phiếu Xuất' },
  { id: 'editExports', label: 'Sửa phiếu Xuất (chưa duyệt)' },
  { id: 'deleteExports', label: 'Hủy phiếu Xuất (chưa duyệt)' },
  { id: 'approveExports', label: 'Duyệt phiếu Xuất' },
  { id: 'viewOrderTracking', label: 'Xem Theo dõi đơn hàng' },
  { id: 'viewInventory', label: 'Xem Tồn Kho' },
  { id: 'editInventory', label: 'Sửa Tồn Kho' },
  { id: 'viewPayable', label: 'Xem Công nợ Nhập' },
  { id: 'viewReceivable', label: 'Xem Công nợ Xuất' },
  { id: 'viewCanTracking', label: 'Xem Theo dõi Vỏ can' },
  { id: 'approveCanRecovery', label: 'Duyệt hàng (can) Nhập kho' },
  // ### CÁC QUYỀN MỚI CHO TRANG CHỈNH SỬA ###
  { id: 'viewEditPage', label: 'Xem trang Chỉnh sửa' },
  { id: 'editApprovedImports', label: 'Sửa/Xóa phiếu Nhập (trang Chỉnh sửa)' },
  { id: 'editApprovedExports', label: 'Sửa/Hủy phiếu Xuất (trang Chỉnh sửa)' },
  { id: 'viewPersonnel', label: 'Xem trang Nhân Viên' },
  { id: 'editPersonnel', label: 'Sửa/Xóa trong trang Nhân Viên' },
  { id: 'viewAllData', label: 'Xem dữ liệu của mọi người' },
  { id: 'viewCreator', label: 'Xem thông tin Người tạo' },
];

function RoleDialog({ open, onClose, onSave, initialRole }) {
  const [roleName, setRoleName] = useState('');
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    if (open) {
      if (initialRole) {
        setRoleName(initialRole.name || '');
        setPermissions(initialRole.permissions || {});
      } else {
        setRoleName('');
        setPermissions({});
      }
    }
  }, [open, initialRole]);

  const handlePermissionChange = (event) => {
    setPermissions({ ...permissions, [event.target.name]: event.target.checked });
  };

  const handleSave = () => {
    if (!roleName) { alert('Vui lòng nhập tên vai trò.'); return; }
    
    let finalPermissions = { ...permissions };

    if (finalPermissions.full_access) {
      allPermissions.forEach(perm => {
        finalPermissions[perm.id] = true;
      });
    }

    onSave({ name: roleName, permissions: finalPermissions });
    onClose();
  };
  
  const masterPermission = allPermissions[0];
  const detailPermissions = allPermissions.slice(1);
  const hasFullAccess = !!permissions[masterPermission.id];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{initialRole ? `Chỉnh sửa Vai trò: ${initialRole.name}` : 'Tạo Vai trò mới'}</DialogTitle>
      <DialogContent>
        <TextField autoFocus margin="dense" label="Tên Vai trò" fullWidth value={roleName} onChange={(e) => setRoleName(e.target.value)} sx={{ mt: 1, mb: 2 }}/>
        <Typography variant="h6">Các quyền hạn:</Typography>
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={hasFullAccess} onChange={handlePermissionChange} name={masterPermission.id} />}
            label={masterPermission.label}
            sx={{backgroundColor: 'rgba(25, 118, 210, 0.08)', p:1, borderRadius: 1, mb: 1}}
          />
          <Divider sx={{my: 1}}/>
          <Grid container>
            {detailPermissions.map(perm => (
              <Grid item xs={12} sm={6} key={perm.id}>
                <FormControlLabel
                  control={<Checkbox checked={hasFullAccess || !!permissions[perm.id]} onChange={handlePermissionChange} name={perm.id} disabled={hasFullAccess} />}
                  label={perm.label}
                />
              </Grid>
            ))}
          </Grid>
        </FormGroup>
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Hủy</Button><Button onClick={handleSave} variant="contained">Lưu</Button></DialogActions>
    </Dialog>
  );
}

export default RoleDialog;
